import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { Observable } from 'rxjs';
import { Document } from '../../../document-data/document.model';
import { Toggles } from '../../../features-data/sub-models/toggles.model';
import { INoItemsOptions } from '../../../feed/feed.interface';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';

@Component({
  selector: 'app-recently-edited-list',
  templateUrl: './recently-edited-list.component.html',
  styleUrls: ['./recently-edited-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecentlyEditedListComponent implements OnInit, OnChanges {
  @Input() recentlyEditedDocuments: Observable<List<Document>>;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() featureToggles: Toggles;

  noItemsOptions: INoItemsOptions;
  enableRecurring: boolean;

  constructor(private _translateService: TranslateService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.featureToggles && this.featureToggles) {
      this.enableRecurring = this.featureToggles.isAllAccess(
        Toggles.KEYS.SCHEDULE
      );
    }
  }

  ngOnInit() {
    this.noItemsOptions = {
      description: this._translateService.instant(
        'HOME.RECENTLY_EDITED_NO_ITEMS'
      ),
    };
  }

  trackDocumentsByFn(index: number, document: Document): string {
    return document.id;
  }
}
